<template>
  <div style="background:#fff">
    <div class="error_500">
      <img src="@/assets/500.png" alt />
      <p>啊哦...服务器链接错误</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>
.error_500 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999999;
  font-size: 18px;
}
.error_500 img {
  width: 150px;
  height: 220px;
}
</style>
